import React from 'react'
import { Http } from 'helpers'
import { Auth } from 'services'
import { Loader } from 'components'

interface Props {
    url: string,
    params: {},
    loadingMessage?: string,
    cache: boolean
}

interface State {
    data: Object,
    hasError: boolean,
    error: {
        title: string,
        message: string
    },
    useDefault: boolean,
    loading: boolean
}

const defaultState = {
    data: {},
    hasError: false,
    error: {
        title: 'Cannot retrieve Real Posts',
        message: 'Could not retrieve Real Posts from supplied API.'
    },
    useDefault: false,
    loading: false,
    loadingMessage: null
}

const hasData = ({
        url = '',
        params = {},
        cache = false
    }): any => (WrappedComponent: any) => {

    class HasData extends React.Component<Props, State> {

        public auth = new Auth()

        public state: State = defaultState

        public componentWillMount() {

            const uri: any = new URL(url)
            let queryParams = params

            Object.keys(queryParams).forEach(key => uri.searchParams.append(key, params[key]))

            if (Object.keys(defaultState.data).length === 0) {

                Http(uri)
                    .then(data => {
                        this.setState({
                            data: data,
                            loading: false,
                            hasError: false,
                            useDefault: data ? data.length === 0 : false
                        })
                        if (cache) {
                            defaultState.data = data
                        }
                    })
                    .catch(() => {
                        this.setState({
                            hasError: true,
                            loading: false
                        })
                    })
                }
        }

        public render() {
            return (
                <React.Fragment>
                    { this.state.data &&
                        Object.keys(this.state.data).length !== 0 ?
                            <WrappedComponent {...this.state} {...this.props} /> :
                            <Loader align="middle" />
                    }
                </React.Fragment>
            )
        }
    }

    return HasData
}

export default hasData



// WEBPACK FOOTER //
// ./src/helpers/hasData/index.tsx